"use client";

import {
  openComparison,
  type ComparisonTarget,
} from "@/components/pricing/comparison-events";

/**
 * Subtle text link used at the bottom of a pricing card to open the worked
 * cost comparison drawer. Rendered as a button for correct dialog semantics.
 */
export function ComparisonLink({
  target,
  children,
  tone = "light",
}: {
  target: ComparisonTarget;
  children: React.ReactNode;
  tone?: "light" | "dark";
}) {
  return (
    <button
      type="button"
      onClick={() => openComparison(target)}
      className={`inline-flex items-center gap-1 text-xs font-semibold transition-colors hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-electric ${
        tone === "dark"
          ? "text-brand-cyan hover:text-white"
          : "text-brand-electric hover:text-brand-navy"
      }`}
    >
      {children}
    </button>
  );
}
